// components/recipe/RecipeCard.js
import React from 'react';
import { Card, Row, Col, Dropdown } from 'antd';
import { MoreOutlined } from '@ant-design/icons';

const RecipeCard = ({
    recipe,
    record,
    keyPhoto,
    ingredients,
    caloriesPerPortion,
    domain,
    menu,
    navigate,
}) => {

    console.log(menu);

    return (
        <Card
            hoverable
            cover={
                keyPhoto ? (
                    <img
                        alt={recipe.name}
                        src={`${process.env.REACT_APP_BACKEND_URL}/recipe/photos/display/${keyPhoto}?width=380&height=180`}
                        style={{ width: '100%', objectFit: 'cover', height: 180 }}
                        onClick={() => navigate(`/ui/recipe/${recipe.id}`)}
                    />
                ) : null
            }
            bodyStyle={{ padding: '12px 16px' }}
        >
            <div
                style={{
                    fontWeight: 600,
                    fontSize: '1.1em',
                    cursor: 'pointer',
                    marginBottom: 8,
                }}
                onClick={() => navigate(`/ui/recipe/${recipe.id}`)}
            >
                {recipe.name}
            </div>
            <div style={{ marginBottom: 12, color: '#555' }}>
                <Row align="top" justify="space-between">
                    <Col flex="20" ellipsis="true">
                        {(ingredients || [])
                            .slice(0, 3)
                            .map((mi) => mi.food?.name)
                            .filter(Boolean)
                            .join(', ')}
                    </Col>

                    <Col span="5" ellipsis="true">
                        {caloriesPerPortion != null && (
  <span
    style={{
      display: 'inline-block',
      padding: '2px 10px',
      borderRadius: 999,
      backgroundColor: 'rgba(0,0,0,0.04)',
      fontSize: 12,
      lineHeight: 1.4,
    }}
  >
    {caloriesPerPortion} cals
  </span>
)}

                    </Col>
                </Row>
            </div>
            <Row
                align="middle"
                justify="space-between"
                style={{ fontSize: '0.9em', color: '#888' }}
            >

                <Col flex="auto" ellipsis="true">
                    {domain}
                </Col>

{menu && (
  <Col>
    <Dropdown overlay={menu(record)} trigger={['click']}>
      <MoreOutlined style={{ fontSize: 18, cursor: 'pointer' }} />  
    </Dropdown>
  </Col>
)}


            </Row>
        </Card>
    );
};

export default RecipeCard;
